import { render } from "./VideoTutorialsView.vue?vue&type=template&id=3f3ceb42"
import script from "./VideoTutorialsView.vue?vue&type=script&lang=js"
export * from "./VideoTutorialsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__